import { formatPhoneNumber } from '@/libraries/PhoneNumber';

export default {
    methods: {
        /**
         * Label of a flash message recipient: the contact name when known, the phone number otherwise
         *
         * @param {object}  message      the scheduled message attributes
         * @param {string}  phoneNumber  the recipient phone number
         *
         * @return {string}
         */
        recipientLabel (message, phoneNumber) {
            const contact = message.audienceContacts?.find(audience => audience.phoneNumber === phoneNumber);

            return contact?.name || formatPhoneNumber(phoneNumber);
        }
    }
};
